<script setup>
import {defineProps, toRefs, defineEmits} from "vue";
import BlockSelector from "@/components/Blocks/BlockSelector.vue";
import BlockRenderer from "@/components/Blocks/BlockRenderer.vue";

const props = defineProps({
  data: {
    type: Object,
    default: () => ({
      columns: [
        {blocks: [], fitContent: false},
        {blocks: [], fitContent: false}
      ],
      columnCount: 2
    })
  },
});
const {data} = toRefs(props);

const emit = defineEmits(['saveBlock'])


function addBlock(columnIndex, block) {
  data.value.columns[columnIndex].blocks.push(block);
  emit('saveBlock', data.value)
}

function removeBlock(columnIndex, blockIndex) {
  data.value.columns[columnIndex].blocks.splice(blockIndex, 1);
  // You might want to implement a method to save the updated data
}

// Implement other necessary methods like moveBlockUp, moveBlockDown, handleOk
</script>

<template>
	<!--	:style="{ display: 'grid', gridTemplateColumns: `repeat(${data.columnCount}, 1fr)`, gap: '20px' }"-->
  <div class="columns columns_block">
    <div v-for="(column, columnIndex) in data.columns" :key="columnIndex" class="column"
         :class="column.fitContent ? 'is-narrow' : ''">
      <div class="block_selector" style="margin-bottom: 20px;">
        <BlockSelector
            @save-block="block => addBlock(columnIndex, block)"
            :length="column.blocks.length"
            :is-column="true"
        />
      </div>
      <BlockRenderer
          :blocks="column.blocks"
          @add-block="block => addBlock(columnIndex, block)"
          @remove-block="blockIndex => removeBlock(columnIndex, blockIndex)"
      />
    </div>
  </div>
</template>

<style scoped>
.columns_block .column:hover .block_selector {
	display: block;
}
.block_selector {
		display: none;
}
</style>